module.exports = __webpack_public_path__ + "3f7d97666764c04e49d88d54a04b1816.svg";